import { render, staticRenderFns } from "./DetectionsTableView.vue?vue&type=template&id=58a9feec&"
import script from "./DetectionsTableView.vue?vue&type=script&lang=js&"
export * from "./DetectionsTableView.vue?vue&type=script&lang=js&"
import style0 from "./DetectionsTableView.vue?vue&type=style&index=0&id=58a9feec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports